import Form from "../form";
import useModal from "../../../../shared/hooks/useModal";
import ReactDOM from 'react-dom';
import { useMediaQuery } from '@mui/material';
import './style.scss'

const ExclusiveItem = ({ isOpenAllList}: any) => {
    const {isOpen, openModal, closeModal} = useModal();
    const isMobile = useMediaQuery('(max-width:767px)');
    return <>
        {isOpenAllList? 
            <ul className="offers__list">
                <li className={`offers__item ${isMobile ?"offers__itemAccent" : ''}`}>
                    <article className="offers__card">
                        <div className="offers__wrapper">
                            <h3 className="offers__name">Квартира в лизинг для юридических лиц</h3>
                                
                            <ul className="offers__sublist">
                                <li>
                                    <p className="offers__key"> Первоначальный взнос 10%</p>
                                </li>
                                <li>
                                    <p className="offers__key">Максимальный срок 5 лет </p>
                                </li>
                                <li>
                                    <p className="offers__key">Быстрый выход на сделку</p>
                                </li>
                            </ul>
                        </div>
                        <img src='/img/offers-1.jpg' width={291} height={145} alt='объект.' />
                        <button className="offers__buttonCard" onClick={openModal}>Оставить заявку</button>
                    </article>
                </li>

                <li className="offers__item">
                    <article className="offers__card">
                        <div className="offers__wrapper">
                            <h3 className="offers__name">Квартиры для семей участников СВО <br /> и семей военнослужащих </h3>

                            <ul className="offers__sublist">
                                <li>
                                    <p className="offers__value"><span>от</span> 20%</p>
                                    <p className="offers__key">Первоначальный взнос</p>
                                </li>
                                <li>
                                    <p className="offers__key">Квартиры в новостройках. <br></br> Получите самые выгодные условия от застройщиков в Новосибирске </p>
                                </li>
                            </ul>
                        </div>
                        <img src='/img/offers-2.png' width={291} height={145} alt='объект.' />
                        <button className="offers__buttonCard" onClick={openModal}>Оставить заявку</button>
                    </article>
                </li>

                {/* <li className="offers__item">
                    <article className="offers__card">
                        <div className="offers__wrapper">
                            <h3 className="offers__name">Обмен квартиры  <br /> на коммерческую недвижимость  </h3>

                                <p className="offers__key">
                                    Получите индивидуальное предложение по обмену вашей квартиры на коммерческую недвижимость в Новосибирске <br />
                                    Повысим доход от арендного бизнеса в 2,5 раза!
                                </p>
                        </div>
                        <img src='/img/offers-3.png' width={291} height={145} alt='объект.' />
                        <button className="offers__buttonCard" onClick={openModal}>Оставить заявку</button>
                    </article>
                </li> */}
            </ul>
            :
            <ul className="offers__list">
                <li className={`offers__item ${isMobile ?"offers__itemAccent" : ''}`}>
                    <article className="offers__card">
                        <div className="offers__wrapper">
                            <h3 className="offers__name">Квартира в лизинг для юридических лиц</h3>
                                
                            <ul className="offers__sublist">
                                <li>
                                    <p className="offers__key"> Первоначальный взнос 10%</p>
                                </li>
                                <li>
                                    <p className="offers__key">Максимальный срок 5 лет </p>
                                </li>
                                <li>
                                    <p className="offers__key">Быстрый выход на сделку</p>
                                </li>
                            </ul>
                        </div>
                        <img src='/img/offers-1.jpg' width={291} height={145} alt='объект.' />
                        <button className="offers__buttonCard" onClick={openModal}>Оставить заявку</button>
                    </article>
                </li>

                <li className="offers__item">
                    <article className="offers__card">
                        <div className="offers__wrapper">
                            <h3 className="offers__name">Квартиры для семей участников СВО <br /> и семей военнослужащих </h3>

                            <ul className="offers__sublist">
                                <li>
                                    <p className="offers__value"><span>от</span> 20%</p>
                                    <p className="offers__key">Первоначальный взнос</p>
                                </li>
                                <li>
                                    <p className="offers__key">Квартиры в новостройках. <br></br> Получите самые выгодные условия от застройщиков в Новосибирске </p>
                                </li>
                            </ul>
                        </div>
                        <img src='/img/offers-2.png' width={291} height={145} alt='объект.' />
                        <button className="offers__buttonCard" onClick={openModal}>Оставить заявку</button>
                    </article>
                </li>

                <li className="offers__item">
                    <article className="offers__card">
                        <div className="offers__wrapper">
                            <h3 className="offers__name">Обмен квартиры  <br /> на коммерческую недвижимость  </h3>

                            <p className="offers__key">
                                Получите индивидуальное предложение по обмену вашей квартиры на коммерческую недвижимость в Новосибирске <br />
                                Повысим доход от арендного бизнеса в 2,5 раза!
                            </p>
                        </div>
                        <img src='/img/offers-3.png' width={291} height={145} alt='объект.' />
                        <button className="offers__buttonCard" onClick={openModal}>Оставить заявку</button>
                    </article>
                </li>

                <li className={`$offers__item ${isMobile ? 'offers__itemAccent' : ''}`}>
                    <article className="offers__card">
                        <div className="offers__wrapper">
                            <h3 className="offers__name">Обмен квартиры на дом</h3>

                            <p className="offers__key">
                                Обмен вашей квартиры на дом в Новосибирске или Новосибирской области
                                Получите подборку выгодных предложений по обмену.
                            </p>
                            <br />
                            <ul className="offers__sublist">
                                <li>
                                    <p className="offers__key"> Обмен быстрее продажи</p>
                                </li>
                                <li>
                                    <p className="offers__key">С доплатой или без</p>
                                </li>
                                <li>
                                    <p className="offers__key">Снижаем ставку по ипотеке</p>
                                </li>
                            </ul>
                        </div>
                        <img src='/img/offers-4.png' width={291} height={145} alt='объект.' />
                        <button className="offers__buttonCard" onClick={openModal}>Оставить заявку</button>
                    </article>
                </li>
            </ul>
        }
        {isOpen && ReactDOM.createPortal(
            <>
                <div className="overlay active" onClick={closeModal}></div>
                <Form modal={true} onSuccess={closeModal} />
            </>,
            document.body
        )}
                
    </>
}

export default ExclusiveItem